import React from 'react';

const Pagination = ({ currentPage, totalPages, pageSize, totalCount, setCurrentPage }) => {
    if (totalPages <= 1) return null;
    return (
        <div className="flex items-center justify-between p-4 border-t border-gray-200">
            <span className="text-sm text-gray-600">
                Showing {((currentPage - 1) * pageSize) + 1} to {Math.min(currentPage * pageSize, totalCount || 0)} of {totalCount || 0} expenses
            </span>
            <div className="flex gap-2 items-center">
                <button
                    disabled={currentPage === 1}
                    onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
                    className="bg-slate-100 hover:bg-slate-200 text-slate-700 text-sm font-semibold rounded-sm px-3 py-2 shadow-none disabled:opacity-50 disabled:cursor-not-allowed"
                >
                    Previous
                </button>
                <span className="text-sm text-gray-600 px-4">
                    Page {currentPage} of {totalPages}
                </span>
                <button
                    disabled={currentPage === totalPages}
                    onClick={() => setCurrentPage(Math.min(totalPages, currentPage + 1))}
                    className="bg-slate-100 hover:bg-slate-200 text-slate-700 text-sm font-semibold rounded-sm px-3 py-2 shadow-none disabled:opacity-50 disabled:cursor-not-allowed"
                >
                    Next
                </button>
            </div>
        </div>
    );
};

export default Pagination;
